export const NameLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // width="288"
      // height="102"
      viewBox="0 0 288 102"
      fill="none"
    >
      <path
        d="M76 22L71 17L76 12L81 17L76 22Z"
        stroke="#E54D2E"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path
        d="M150 72L145 67L150 62L155 67L150 72Z"
        stroke="#E54D2E"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path
        d="M65.5 92C15.5 92 15.5 42 65.5 42C115.5 42 115.5 92 65.5 92Z"
        stroke="#E54D2E"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path
        d="M160.5 92C110.5 92 110.5 42 160.5 42C210.5 42 210.5 92 160.5 92Z"
        stroke="#E54D2E"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path
        d="M234.5 66C184.5 66 184.5 16 234.5 16C284.5 16 284.5 66 234.5 66Z"
        stroke="#E54D2E"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path
        d="M273.5 13V63"
        stroke="#E54D2E"
        strokeWidth="16"
        strokeLinecap="square"
      />
      <path
        d="M224 39L213.5 87H275.5"
        stroke="#E54D2E"
        strokeWidth="16"
        strokeLinecap="square"
      />
      <path
        d="M11 17H45"
        stroke="#E54D2E"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path
        d="M106 17H174"
        stroke="#E54D2E"
        strokeWidth="15"
        strokeLinecap="square"
      />
      <path d="M11 58L26 18H30L51 74" stroke="#E54D2E" strokeWidth="15" />
      <path
        d="M106 58L121 18H125L135.5 46"
        stroke="#E54D2E"
        strokeWidth="15"
      />
    </svg>
  );
};
